import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

import banner1 from "../../Assets/Images/banner1.webp";
import banner2 from "../../Assets/Images/banner2.webp";
import banner3 from "../../Assets/Images/banner3.webp";
import banner4 from "../../Assets/Images/banner4.webp";
import banner5 from "../../Assets/Images/banner5.webp";


const Banner = () => {
    return (
        <>
            <div className="contanier-fluid mx-0">

                <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    // navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    // scrollbar={{ draggable: true }}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}
                >
                    <SwiperSlide>
                        <img src={banner1} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner2} width={"100%"} alt="" />

                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner3} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner4} width={"100%"} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={banner5} width={"100%"} alt="" />
                    </SwiperSlide>
                </Swiper>
            </div>

        </>
    )
}

export default Banner